(function(window, angular) {
  "use strict";
  var m = angular.module("vvCommon");

  m.directive('vvPopupLayer', function(vvPopup, $compile, $q, $timeout, vv) {
    return {
      scope: true,
      link: function(scope, element, attrs) {
        var layerDeferred = null;
        var layerScope = null;

        function openLayer(template, data) {
          var popup;
          if (data != null) {
            layerScope = scope.$new();
            angular.extend(layerScope, data);
            popup = $compile(template)(layerScope);
          } else {
            popup = $compile(template)(scope);
          }

          element.append(popup);
          scope.showLayer = true;
        }

        function closeLayer(fade, duration) {
          if (duration == null)
          duration = 0;
          var promises = [];
          if (fade && vv.$('.layer-nodim')) {
            promises.push($timeout(function () { vv.$('.layer-nodim').fadeOut(duration); }, 0));
          }

          promises.push($timeout(function () {
            scope.showLayer = false;
            scope.copied = false;
            element.empty();
            if (layerScope != null) {
              layerScope.$destroy();
              layerScope = null;
            }
          }, duration));
          return $q.all(promises);
        }

        scope.notifyPopup = function($event, action) {
          if (layerDeferred != null) {
            layerDeferred.notify(action);
          }
        };

        scope.closePopup = function($event, action) {
          console.log($event, action)
          if (layerDeferred != null) {
            layerDeferred.resolve(action);
            closeLayer();
            layerDeferred = null;
          }
        };

        scope.copyText = function() {
          var el = document.querySelector('.input-text');
          el.focus();
          el.setSelectionRange(0, el.value.length);

          try {
            var success = document.execCommand('copy');
            if (success)
            scope.copied = true;
          } catch(e) {
            console.log(e);
          }
        };

        vvPopup.setHandler({
          open: function(template, data) {
            var p = $q.when(null);
            if (layerDeferred != null) {
              layerDeferred.reject();
              p = closeLayer();
              layerDeferred = null;
            }

            p.then(function() {
              openLayer(template, data);
            });

            layerDeferred = $q.defer();
            return layerDeferred.promise;
          },
          close: function(fade, duration) {
            if (layerDeferred == null)
            return $q.reject('no open popup layer');

            layerDeferred.resolve();
            closeLayer(fade, duration);
            var promise = layerDeferred.promise;
            layerDeferred = null;
            return promise;
          }
        });

        scope.$on('$destroy', function() {
          if (layerDeferred != null) {
            layerDeferred.reject(false);
            closeLayer();
          }
        });
      }
    };
  });
})(window, window.angular);
